import Vue from 'vue'
import Router from 'vue-router'
import Index from './views/lottery/Index.vue'

Vue.use(Router)

export default new Router({
    routes: [
        {
          path: '/',
          name: 'Index',
          component: Index
        },
        /*{
          path: '/lottery',
          name: 'Lottery',
          component: () => import(/!* webpackChunkName: "lottery" *!/ './views/lottery/Index.vue')
        },*/
        {
            path: '/lottery/apply',
            name: 'Apply',
            component: () => import(/* webpackChunkName: "lottery" */ './views/lottery/ApplicationInfo.vue')
        },
        {
            path: '/lottery/result',
            name: 'Result',
            component: () => import(/* webpackChunkName: "lottery" */ './views/lottery/ResultInfo.vue')
        },
        {
            path: '/error',
            name: 'Error',
            component: () => import(/* webpackChunkName: "error" */ './views/Error.vue')
        },
        {
            path: '/lottery/detail',
            name: 'DisplayDetails',
            component: () => import(/* webpackChunkName: "detail" */ './views/lottery/DisplayDetails.vue')
        },
        {
            path: '/lottery/apply-2',
            name: 'SecondApply',
            component: () => import(/* webpackChunkName: "apply-2" */ './views/lottery/SecondApply.vue')
        },
        {
            path: '/lottery/winprize',
            name: 'WinPrize',
            component: () => import(/* webpackChunkName: "winprize" */ './views/lottery/WinPrize.vue')
        },
        {
            path: '/lottery/activityrule',
            name: 'ActivityRule',
            component: () => import(/* webpackChunkName: "activityrule" */ './views/lottery/ActivityRule.vue')
        }
    ]
})
